import { render, staticRenderFns } from "./sale_customer_list.vue?vue&type=template&id=477e759e&scoped=true"
import script from "./sale_customer_list.vue?vue&type=script&lang=js"
export * from "./sale_customer_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477e759e",
  null
  
)

export default component.exports